import { ofType } from "redux-observable";
import { from, of } from "rxjs";
import { catchError, mergeMap, switchMap } from "rxjs/operators";
import { GET_TERM_REPORT_CONFIGS_REQUEST } from "../../../actions/types";
import { getTermReportConfigs } from "../../../actions";
export var getTermReportConfigsEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe(ofType(GET_TERM_REPORT_CONFIGS_REQUEST), switchMap(function(action) {
        return from(api.reportsCenterService.getTermReportConfigs(action.payload).pipe(mergeMap(function(response) {
            var _response_termReportConfigurationsList;
            return of(getTermReportConfigs.success((_response_termReportConfigurationsList = response === null || response === void 0 ? void 0 : response.termReportConfigurationsList) !== null && _response_termReportConfigurationsList !== void 0 ? _response_termReportConfigurationsList : []));
        }), catchError(function(err) {
            return of(getTermReportConfigs.failure(err));
        })));
    }));
};
export default getTermReportConfigsEpic;

//# sourceMappingURL=index.js.map